module.exports = "<div class=\"card card--fixedWidth\">\n  <div class=\"card__description\">\n    <div class=\"icon fa fa-flask card__descriptionIcon\"></div>\n    <div class=\"card__descriptionText\">Science potion</div>\n  </div>\n  <div class=\"card__price\">Costs $5</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/raw-loader!/Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/flexbox-patterns/src/examples/card.html
// module id = 743
// module chunks = 0